import React, {FC} from 'react';

type OwnDeclarationAddInputsProps = {
  handleChange: Function;
  removeFormFields: Function;
  name: string;
  text: string;
  index: number;
  nameError: string;
  textError: string;
}

const OwnDeclarationAddInputs: FC<OwnDeclarationAddInputsProps> = ({
  handleChange,
  removeFormFields,
  name,
  text,
  index,
  nameError,
  textError,
}) => {
  return (
    <div className='pt-6 relative'>
      <div className='underline text-sm font-bold pb-2'>Fråga {index + 1}:</div>
      <div className='bg-gray-menu rounded flex flex-col p-5'>
        <label className='text-xs text-gray-700 pb-2'>Fyll i påstående på svenska:</label>
        <input
          type="text"
          name="name"
          value={name || ''}
          className='border pl-2 relative bg-white md:bg-white md:text-navy-black md:h-auto
          md:border-neutral-300 md:rounded-md h-full border-neutral-600 rounded-15 py-2'
          onChange={(e) => handleChange(index, e)}
        />
        {nameError && nameError.length > 0 && (
          <span className='text-sm text-red-form'>{nameError}</span>
        )}
        <label className='text-xs text-gray-700 py-2'>Fyll i påstående på engelska:</label>
        <input
          type="text"
          name="text"
          value={text || ''}
          onChange={(e) => handleChange(index, e)}
          className='border pl-2 relative bg-white md:bg-white md:text-navy-black md:h-auto
          md:border-neutral-300 md:rounded-md h-full border-neutral-600 rounded-15 py-2'
        />
        {textError && textError.length > 0 && (
          <span className='text-sm text-red-form'>{textError}</span>
        )}
      </div>
      {index ?
        <button
          type="button"
          className='underline text-sm text-red-800 absolute right-0 pt-2'
          onClick={() => removeFormFields(index)}>Radera</button> :
        null
      }
    </div>
  );
};

export default OwnDeclarationAddInputs;
